/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function EyeIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="eye"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={12} cy={12} r={3.354} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.5 12A10.192 10.192 0 0 1 21.5 12" data-tinysvg-shape="arc" data-tinysvg-arc="12 15.692 10.192 10.192 201.24 338.76 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M21.5 12A10.192 10.192 0 0 1 2.5 12" data-tinysvg-shape="arc" data-tinysvg-arc="12 8.308 10.192 10.192 21.24 158.76 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
